import React from 'react';
import { EcoAssociation9Class2026 } from '../views';

const AccountGeneralPage = () => {
  return <EcoAssociation9Class2026/>;
};

export default AccountGeneralPage;